import { OrderingInitialState, ToggleDetailsVisibilityAction } from '@reducers/ordering/types';

export const toggleDetailsVisibility = (
  state: OrderingInitialState,
  action: ToggleDetailsVisibilityAction
): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    isMenuItemDetailsVisible: action.payload,
  },
});
